/* eslint-disable */

/*ApiVersionCheckService
 *  Detect when there is a new version of the client available
 *  Detect the API minimum client version and force update if violated
 *
 *Firebase
 *  _api-version
 *    current: #
 *  _client-version
 *    current:
 *      web: #
 *      android: #
 *      ios: #
 *    minimum
 *      web: #
 *      android: #
 *      ios: #
 */

'use strict';
import {CLIENT_VERSION, isCordovaBuild} from '../../config/constants';
import {naturalCompare} from '../../core-utilities/filters/filterUtils';


const SEMVER_REGEXP = /^([0-9]+)\.([0-9]+)\.([0-9]+)(?:-([0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*))?(?:\+[0-9A-Za-z-]+)?$/;

ApiVersionCheckService.$inject = [
  '$window',
  'FirebaseUtil',
  '$filter',
  '$toast',
];

// TODO: add a mechanism for forcing local cache resets as part of the API versioning system
export function ApiVersionCheckService(
  $window,
  FirebaseUtil,
  $filter,
  $toast,
) {
  let compareVersionsNew;
  let compareVersionsExpired;
  this.init = init;

  function init() {
    FirebaseUtil.firebaseRef('_client-version').on('value', ss => tryCatch(onVersionChange, ss));
  }

  function onVersionChange(clientVersionSnapshot) {
    const clientVersionData = clientVersionSnapshot.val();

    const platform = ionic.Platform.isIOS() || ionic.Platform.isIPad() ? 'ios' : ionic.Platform.isAndroid() ? 'android' : 'web';

    const clientVersion = new Version(CLIENT_VERSION);
    const minimumVersion = new Version(clientVersionData.minimum[platform]);
    const availableVersion = new Version(clientVersionData.available[platform]);

    // TODO: if the app is out of date (below minimum), it actually needs to block the user interface, like rerouting to a warning view with instructions of how to update by platform
    if (isCordovaBuild()) {
      if (compareVersions(clientVersion, minimumVersion) === -1) {
        // TODO: open an un-closable modal that informs the user that they must update the app to continue using the app
        $toast.showMessage('Your app version is no longer supported. Please install the latest version.', null, 'warning', {
          closeButton: true,
          toastOptions: {
            autoClose: false,
          },
        });
      } else if (compareVersions(clientVersion, availableVersion) === -1) {
        // TODO: convert to a better UI component. it may need to link to documentation for how to update from the app store?
        $toast.showMessage('A new version is available to install from the app store!', null, 'info', {
          closeButton: true,
          toastOptions: {
            autoClose: false,
          },
        });
      }
    } else {
      if (compareVersions(clientVersion, minimumVersion) === -1) {
        if ($toast.isActive(compareVersionsNew)) {
          return
        }
        // TODO: navigate to the updates settings view that blocks back availability
        // TODO: also figure out a way to force them back to that view should they a figure out a way to leave it
        //    check into the hardware back action service. it should allow them to leave the app rather than go to a previous view in the app
        //    I think simply clearing the app history stack should accomplish this but we need to verify
        compareVersionsNew = $toast.showMessageSync('Your app version is no longer supported. You may need to hard refresh the page to get the latest version', null, 'warning', {
          closeButton: true,
          action: {
            className: 'button button-small button-assertive',
            label: 'Update',
            handler: refreshPage,
          },
          toastOptions: {
            autoClose: false,
          },
        });
      } else if (compareVersions(clientVersion, availableVersion) === -1) {
        if (compareVersionsExpired && $toast.isActive(compareVersionsExpired)) {
          return
        }
        // TODO: convert to a better UI component. it needs both a close and an "update now" functionality
        // TODO: if the user taps the update button in the popup, navigate to the updates settings view
        // TODO: consider a "snooze" functionality to remind you later. This would prevent further popups about updates
        //    until the snooze expiration, unless their version drops below the minimum
        compareVersionsExpired = $toast.showMessageSync('New version available!', null, 'info', {
          closeButton: true,
          action: {
            className: 'button button-small button-balanced',
            label: 'Update',
            handler: refreshPage,
          },
          toastOptions: {
            autoClose: false,
          },
        });
      }
    }
  }

  function refreshPage() {
    $window.location.reload(true);
  }
}

// 1 if v1 is newer
// 0 if equal
// -1 if v1 is older
export function compareVersions(v1, v2) {
  if (v1.toString() === v2.toString()) {
    return 0;
  } else {
    if (v1.major > v2.major) {
      return 1;
    } else if (v1.major < v2.major) {
      return -1;
    } else {
      if (v1.minor > v2.minor) {
        return 1;
      } else if (v1.minor < v2.minor) {
        return -1;
      } else {
        if (v1.patch > v2.patch) {
          return 1;
        } else if (v1.patch < v2.patch) {
          return -1;
        } else {
          if (v1.prerelease === v2.prerelease) {
            return 0;
          } else if (!v1.prerelease && v2.prerelease) {
            return 1;
          } else if (v1.prerelease && !v2.prerelease) {
            return -1;
          } else {
            return naturalCompare(v1.prerelease, v2.prerelease, true, true);
          }
        }
      }
    }
  }
}

export function Version(value) {
  const match = value.match(SEMVER_REGEXP);
  return {
    major: parseInt(match[1]),
    minor: parseInt(match[2]),
    patch: parseInt(match[3]),
    prerelease: match[4] || null,
    toString: () => value,
  }
}

function tryCatch(fn, ss) {
  try {
    fn(ss);
  } catch (e) {
  }
}



// WEBPACK FOOTER //
// ./src/js/settings/services/ApiVersionCheckService.js